import { Card, Col, Row, Select, Space, Spin, Statistic, Tooltip } from 'antd';
import React, { useState } from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import UsageStatistic from './UsageStatistic';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@fortawesome/fontawesome-svg-core';

interface MeetingsUsageListProps {
  company: Company | undefined;
}

export default function MeetingsUsage({
  company,
}: MeetingsUsageListProps) {
    
  const [range, setRange] = useState(30);
  const meetingsUsage = CustomerServiceQueries.useCompanyUsageMeetings(company!.id, range)

  const handleChange = (value: string) => {
    setRange(Number(value))
  };

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faCalendar as Icon}/> Meetings</Space>} extra={<Select
      defaultValue={range.toString()}
      style={{ width: 160 }}
      onChange={handleChange}
      loading={meetingsUsage.isFetching}
      options={[
        {
            value: "0",
            label: 'All Time',
        },{
            value: "-365",
            label: 'Past 365 Days',
        },
        {
            value: "-120",
            label: 'Past 120 Days',
        },
        {
            value: "-90",
            label: 'Past 90 Days',
        },
        {
            value: "-60",
            label: 'Past 60 Days',
        },
        {
            value: "-30",
            label: 'Past 30 Days',
        },
        {
          value: "30",
          label: 'Next 30 Days',
        },
        {
          value: '60',
          label: 'Next 60 Days',
        },
        {
          value: '90',
          label: 'Next 90 Days',
        },
        {
          value: '120',
          label: 'Next 120 Days',
        },
        {
          value: '365',
          label: 'Next 365 Days',
        }
      ]}
    />} >
        <Spin spinning={meetingsUsage.isLoading}>
            
    <Row gutter={[16,16]}>
        {meetingsUsage.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item}/>
            </Col>
        ))}
    </Row>
        </Spin>
    </Card>
    </>
  );
}
